var map = {
	"./computer/Token/Token.vue": [
		"83d4",
		"chunk-6cd4d875"
	],
	"./mobile/Token/Token.vue": [
		"e488",
		"chunk-68bc01ab"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f668";
module.exports = webpackAsyncContext;